import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '@store';
export const loderSelector = createSelector(
  (state: AppState) => state.loaderReducer,
  (loaderReducer: boolean) => loaderReducer
);
